import axiosInstance from '../../../core/api/interceptors/axiosInterceptor';

const SHOPIFY_API_URL = '/Shopify';

/**
 * Get all Shopify products
 * @param {number} limit - Number of products to fetch (default: 50)
 * @param {number|null} sinceId - Fetch products after this ID
 * @returns {Promise}
 */
export const getShopifyProducts = async (limit = 50, sinceId = null) => {
  try {
    
    const params = new URLSearchParams();
    params.append('limit', limit.toString());
    if (sinceId) {
      params.append('sinceId', sinceId.toString());
    }

    const response = await axiosInstance.get(`${SHOPIFY_API_URL}/products?${params.toString()}`);
    
    return response.data;
  } catch (error) {
    console.error('❌ Error fetching Shopify products:', error);
    throw error;
  }
};

/**
 * Get a single Shopify product by ID
 * @param {number} productId - Product ID
 * @returns {Promise}
 */
export const getShopifyProduct = async (productId) => {
  try {
    
    const response = await axiosInstance.get(`${SHOPIFY_API_URL}/products/${productId}`);
    
    return response.data;
  } catch (error) {
    console.error('❌ Error fetching Shopify product:', error);
    throw error;
  }
};

/**
 * Create a new Shopify product
 * @param {Object} productData - Product data
 * @returns {Promise}
 */
export const createShopifyProduct = async (productData) => {
  try {
    
    const response = await axiosInstance.post(`${SHOPIFY_API_URL}/products`, productData);
    
    return response.data;
  } catch (error) {
    console.error('❌ Error creating Shopify product:', error);
    throw error;
  }
};

/**
 * Update an existing Shopify product
 * @param {number} productId - Product ID
 * @param {Object} productData - Updated product data
 * @returns {Promise}
 */
export const updateShopifyProduct = async (productId, productData) => {
  try {
    const response = await axiosInstance.put(`${SHOPIFY_API_URL}/products/${productId}`, {
      ...productData,
      id: productId
    });
    
    return response.data;
  } catch (error) {
    console.error('❌ Error updating Shopify product:', error);
    throw error;
  }
};

/**
 * Delete a Shopify product
 * @param {number} productId - Product ID
 * @returns {Promise}
 */
export const deleteShopifyProduct = async (productId) => {
  try {
    
    const response = await axiosInstance.delete(`${SHOPIFY_API_URL}/products/${productId}`);
    
    return response.data;
  } catch (error) {
    console.error('❌ Error deleting Shopify product:', error);
    throw error;
  }
};

/**
 * Get Shopify product count
 * @returns {Promise}
 */
export const getShopifyProductCount = async () => {
  try {
    
    const response = await axiosInstance.get(`${SHOPIFY_API_URL}/products/count`);
    
    return response.data;
  } catch (error) {
    console.error('❌ Error fetching Shopify product count:', error);
    throw error;
  }
};